import styled, { css, keyframes } from 'styled-components';
import callerIcon from './caller-icon.svg';
import { CALLER_COLORS as C } from './tokens';

type Props = {
  count?: number; // incoming-call count shown in the badge
  onClick?: () => void;
};

// Floating caller-ID action button: orange squircle with a white phone icon, an
// "incoming call" pulse ring, and a count badge. Positioning is owned by the
// page wrapper (.wrapper-caller-btn); this component owns the look + animation.
const FloatingButton = ({ count = 0, onClick }: Props) => (
  <FabButton type="button" onClick={onClick} aria-label="Caller ID" $pulse={count > 0}>
    <img src={callerIcon} alt="" />
    {count > 0 && <Badge>{count > 99 ? '99+' : count}</Badge>}
  </FabButton>
);

export default FloatingButton;

// Expanding ring that radiates out and fades — signals a live incoming call.
const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(251, 78, 0, 0.45);
  }
  70% {
    box-shadow: 0 0 0 14px rgba(251, 78, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(251, 78, 0, 0);
  }
`;

const FabButton = styled.button<{ $pulse?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 16px;
  background: ${C.accentOrange};
  border: none;
  cursor: pointer;
  ${({ $pulse }) => $pulse && css`animation: ${pulse} 1.8s ease-out infinite;`}
  &:active {
    opacity: 0.85;
  }
  img {
    width: 24px;
    height: 24px;
  }
`;

const Badge = styled.span`
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${C.red};
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  border-radius: 999px;
  border: 2px solid #fff;
  box-sizing: border-box;
`;
